import { render, staticRenderFns } from "./PresentationContent.vue?vue&type=template&id=516c88ae&scoped=true"
import script from "./PresentationContent.vue?vue&type=script&lang=js"
export * from "./PresentationContent.vue?vue&type=script&lang=js"
import style0 from "./PresentationContent.vue?vue&type=style&index=0&id=516c88ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516c88ae",
  null
  
)

export default component.exports